import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import Switch from '../../../../components/UI/Switch/Switch';
import Confirm from '../../../../components/UI/Confirm/Confirm';
import Modal from '../../../../components/UI/Modal/Modal';
import classes from './DeviceSteeringto2.4.css';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import { FaInfoCircle } from 'react-icons/fa';
import DeviceSterringCountDownTimer from '../../../DeviceSteering/DeviceSterringCountDownTimer/DeviceSterringCountDownTimer';

const DeviceSteeringtwoFour = (props) => {
    const [state, setState] = useState({
        isToggleEnabled: false,
        isConfirmModalOpen: false,
        confirmModalResult: '',
        showTooltip: false,
        DeviceSteeringToggle: ''
    });

    const [showSpinner, setShowSpinner] = useState(false);
    const [expiresAt, setExpiresAt] = useState(null);

    useEffect(() => {
        const { forced: f = { expiresAt: null } } = props.steering || {}
        const { expiresAt: e = null } = f
        setExpiresAt(e)
        setShowSpinner(!!expiresAt === null ? true : false);
        if (expiresAt === null && props.steering?.forced) {
            setShowSpinner(false)
            setExpiresAt(props.steering.forced.expiresAt)
        }
    }, [props.steering, expiresAt])

    useEffect(() => {
        if(props.isCurrentlyPolling){
            setExpiresAt(props.isCurrentlyPolling)
            setShowSpinner(false)
        }
    }, [props.isCurrentlyPolling])

    const handleToggle = (event) => {
        const { checked } = event.target;
        // console.log('props :::', props);
        // Need to check the schedule Timing before enabling.
        // console.log('handle Device Steerin ::', props.customTemp , props.handleDeviceSteering(props.customTemp));
        if (props.isDeviceSuspend || !props.handleDeviceSteering(props.customTemp, 'addSteering', props.originalDevice.freeze.frozen)) {
            const message = checked
                ? 'This will steer the device to 2.4 GHz. This may take some time to complete. During this time, some devices may disconnect. Please follow CO-Pilot article HOW5466 for further assistance - do not attempt to reconnect until the timer begins.'
                : 'Customers device is currently being steered to 2.4GHz this will end steering.'
            setState(state => ({
                ...state,
                isConfirmModalOpen: true,
                confirmModalResult: message
            }));

        }

    }

    const confirmModalCancelHandler = () => {
        setState(s => ({
            ...s,
            isConfirmModalOpen: false,
            showTimer: props.isDeviceSteeringtwoFour,
            confirmModalResult: '',
        }))
    }

    const confirmModalConfirmHandler = () => {
        if (expiresAt === null) {
            setShowSpinner(true);
            props.startSteering({ routerMac: props.routerMac, deviceMac: props.originalDevice.mac })
        } else {
            props.stopSteering({ routerMac: props.routerMac, deviceMac: props.originalDevice.mac })
        }
        setState({
            ...state,
            isToggleEnabled: !state.isToggleEnabled,
            isConfirmModalOpen: false,
        })
    }

    const handleTimeEnd = () => {
        props.stopSteering({ routerMac: props.routerMac, deviceMac: props.originalDevice.mac })
        setExpiresAt(false);
    }

    const deviceSteeringConfirmationModal = useMemo(() =>  {
        return (
          <>
            <Modal
              show={state.isConfirmModalOpen}
              modalClosed={confirmModalCancelHandler}
              customStyle={{
                width: "65%",
                transform: `translate(${window.innerWidth > 600 ? '-125px' : '0px'}, 148px)`,
                border: "none",
                borderRadius: "8px",
                zIndex: 1000
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <span>
                  <FaInfoCircle
                    color='#38a9f9'
                    size={24}
                    style={{ display: "flex", marginRight: "5px", marginLeft: "5px" }}
                  />
                </span>
                <h3 className={classes.SteeringAllButton}>Device Steer</h3>
              </div>
                <Confirm
                    id={"DeviceSteeringtwoFourConfirm"}
                    result={state.confirmModalResult}
                    confirm={confirmModalConfirmHandler}
                    confirmButtonLabel='Proceed'
                    cancel={confirmModalCancelHandler}
                    subText={"Do you wish to proceed?"}
                    deviceGroupConfirmation
                    headerStyle={classes.headerStyle}
                    footerStyle={classes.footerStyle}
                />
            </Modal>
          </>
        );},[state.isConfirmModalOpen]);

    const displayToolTip = (show) => {
        if (props.isTwoFourSteeringEnabled || props.isDisabled) {
            setState((state) => ({ ...state, showTooltip: show }))
        }
    }

    return (
        <div className={classes.DeviceSteeringtwoFour}>
            <span id='deviceSteeringTxT' >Device Steering to 2.4 GHz</span>
            <div className={classes.DeviceSteeringtwoFourToggle}>
                {
                    !!showSpinner
                        ? <Spinner />
                        : (
                            !!expiresAt
                                ? <DeviceSterringCountDownTimer
                                    className={classes.Timer}
                                    handleTimeEnd={handleTimeEnd}
                                    expiresAt={expiresAt}
                                />
                                : null
                        )
                }
                <div id="ExclusionToggle" className={[classes.switchclass].join(' ')}
                    onMouseOver={() => {displayToolTip(true)}}
                    onMouseOut={() => {displayToolTip(false)}}
                >
                    {state.showTooltip && props.isTwoFourSteeringEnabled &&
                        <span id='DSDisabledMSG' className={classes.tooltipclass}>Device is connected to 2.4 GHz. Steering cannot be initiated.</span>
                    }
                    {/* {state.showTooltip && props.isDisabled && !props.isTwoFourSteeringEnabled &&
                        // <span id='DSDisabledMSG' className={classes.tooltipclass}>Phone/tablet must not be paused to initiate steering</span>
                    } */}

                    <Switch
                        id='DeviceSteeringToggle'
                        aria-checked={!!expiresAt}
                        checked={!!expiresAt}
                        aria-label="Toggle device steering"
                        onText="ON"
                        offText="OFF"
                        disabled={props.isDisabled || props.isTwoFourSteeringEnabled}
                        onChange={handleToggle}
                    />
                </div>
            </div >
            { state.isConfirmModalOpen && deviceSteeringConfirmationModal }
        </div >
    )
}

const mapStateToProps = (state) => ({
    isCurrentlyPolling: state.deviceSteering.pollingExpiresAt,

})

export default connect(mapStateToProps)(DeviceSteeringtwoFour);
